/**
 * Lib.Common: v-num directive
 *
 * Populate element content with formatted number.
 */


import $num from '../prototype/num';

const emDash = '—';


function update(el, binding) {
    const value = binding.value;
    const state = el.__num__;
    if (value !== state.v) {
        const html = state.fn(value);
        const nan = html === emDash;
        if (nan != state.n) {
            if (nan) {
                el.classList.add('_nan');
            } else {
                el.classList.remove('_nan');
            }
        }
        if (binding.modifiers.color) {
            const ncl = state.c;
            const cls = state.d(value);
            if (ncl !== cls) {
                if (ncl) {
                    el.classList.remove(ncl);
                }
                if (cls) {
                    el.classList.add(cls);
                }
                state.c = cls;
            }
        }
        el.innerHTML = html;
        state.v = value;
        state.n = nan;
    }
}

function bind(el, binding) {
    const mod = binding.modifiers;
    const smallFraction = mod.smallFraction;
    const smallPercent = mod.smallPercent;
    const smallCurrency = mod.smallCurrency;
    const smallAbbrev = mod.smallAbbrev;

    let fn =
        mod.raw         ? $num.raw :
        mod.bytes       ? $num.bytes :
        mod.int         ? $num.int :
        mod.fixed       ? $num.fixed :
        mod.fixed1      ? $num.fixed1 :
        mod.fixed3      ? $num.fixed3 :
        mod.fixed4      ? $num.fixed4 :
        mod.fixed5      ? $num.fixed5 :
        mod.fixed6      ? $num.fixed6 :
        mod.min2        ? $num.min2 :
        mod.max4        ? $num.max4 :
        mod.percent     ? $num.percent :
        mod.percent1    ? $num.percent1 :
        mod.percent2    ? $num.percent2 :
                          $num.decimal;

    if (mod.flex && fn.flex) {
        fn = fn.flex;
    } else if (mod.compact && fn.compact) {
        fn = fn.compact;
    }
    if (mod.flat && fn.flat) {
        fn = fn.flat;
    } else if (mod.sign && fn.sign) {
        fn = fn.sign;
    }

    if (smallFraction || smallPercent || smallCurrency || smallAbbrev || mod.compact) {
        const parts = fn.parts;
        fn = function(num) {
            let p = parts(num);
            let r = '';
            for (let i = 0; i < p.length; i++) {
                let value = p[i].value;
                let type = p[i].type;
                if (
                    type == 'fraction' && smallFraction ||
                    type == 'percentSign' && smallPercent ||
                    type == 'currency' && smallCurrency ||
                    type == 'compact' && (smallAbbrev || mod.compact && value.length > 1)) {
                    r += '<small>' + value + '</small>';
                } else {
                    r += value;
                }
            }
            return r;
        }
    }

    el.__num__ = {
        fn,
        v: !binding.value,
        n: false,
        c: null,
        d: mod.raw
            ? value => /^-/.test(value) ? 'fg-negative' : /[1-9]/.test(value) ? 'fg-positive' : void 0
            : value => value < 0 ? 'fg-negative' : value > 0 ? 'fg-positive' : void 0
    };
    update(el, binding);
}

function unbind(el) {
    el.innerHTML = '';
}

export default {
    name: 'num',
    directive: {
        bind,
        unbind,
        update
    }
};
